var CustomRedactorButtons = {

	classes: {
		title: "Add Classes",
		dropdown: {

			cpromo: {
				title: 'cpromo',
				callback: function(buttonName, buttonDOM, buttonObj) {
					if (this.getParent().getAttribute('class') && this.getParent().getAttribute('class').search('cpromo')>=0)
						this.blockRemoveClass('cpromo');
					else 
						this.blockSetClass('cpromo');
				}
			},

			promo: {
				title: 'promo',
				callback: function(buttonName, buttonDOM, buttonObj) {
					if (this.getParent().getAttribute('class') && this.getParent().getAttribute('class').search('promo')>=0)
						this.blockRemoveClass('promo');
					else 
						this.blockSetClass('promo');
				}
			},

			ipbox: {
				title: 'ipbox',
				callback: function(buttonName, buttonDOM, buttonObj) {
					if (this.getParent().getAttribute('class') && this.getParent().getAttribute('class').search('ipbox')>=0)
						this.blockRemoveClass('ipbox');
					else 
						this.blockSetClass('ipbox');
				}
			},

			'blue-background': {
				title: 'blue-background',
				callback: function(buttonName, buttonDOM, buttonObj) {
					if (this.getParent().getAttribute('class') && this.getParent().getAttribute('class').search('blue-background')>=0)
						this.blockRemoveClass('blue-background');
					else 
						this.blockSetClass('blue-background');
				}
			},

			notice: {
				title: 'notice (grey text)',
				callback: function(buttonName, buttonDOM, buttonObj) {
					if (this.getParent().getAttribute('class') && this.getParent().getAttribute('class').search('notice')>=0)
						this.blockRemoveClass('notice');
					else 
						this.blockSetClass('notice');
				}
			},

			'gold-text': {
				title: 'gold text',
				callback: function(buttonName, buttonDOM, buttonObj) {
					if (this.getParent().getAttribute('class')=='gold-text')
						this.inlineRemoveClass('gold-text'); 
					else 
						this.inlineSetClass('gold-text');
				}
			},

			alert: {
				title: 'alert (red text)',
				callback: function(buttonName, buttonDOM, buttonObj) {
					if (this.getParent().getAttribute('class')=='alert-text')
						this.inlineRemoveClass('alert-text'); 
					else 
						this.inlineSetClass('alert-text');
				}
			},

			tab: {
				title: 'tab',
				callback: function(buttonName, buttonDOM, buttonObj) {
					this.insertText('{tab=TABNAME}');
				}
			}

		}

	},

	superscript: {
	    title: 'Superscript',
	    callback: function(obj, event, key) {
	        this.execCommand('superscript')
	    }
	},

	subscript: {
	    title: 'Subscript',
	    callback: function(obj, event, key) {
	        this.execCommand('subscript')
	    }
	},

	id: {
	    title: 'ID',
	    callback: function(obj, event, key) {
	    	//this.blockRemoveAttr('id');
	        //this.blockSetAttr('id', 'something');
	        var callback = $.proxy(function()
	        {
	            this.selectionSave();

	            $('#redactor_modal #closeidmodal').click($.proxy(function()
	            {
	                this.selectionRestore();
			    	this.blockRemoveAttr('id');
			        this.blockSetAttr('id', $('#idmodal [name=idname]').val());
			        this.modalClose();
	                return false;

	            }, this));

	        }, this);
	        this.modalInit('Add ID for Anchor', '<div id="idmodal"><section><label>Name the ID:</label><input name="idname" type="text" class="redactor_input"></section><footer></input><button id="closeidmodal" class="redactor_modal_btn">Insert</button></footer></div>', 500, callback);
	    }
	}

}

// var CustomRedactorListStyles = {
	
// 	liststyles: {
// 		title: "List Styles",
// 		dropdown: {
			
// 			ipdash: {
// 				title: '&mdash; ipdash',
// 				callback: function(buttonName, buttonDOM, buttonObj) {
// 					if (this.getParent().getAttribute('class') && this.getParent().getAttribute('class').search('ipdash')>=0)
// 						this.blockRemoveClass('ipdash');
// 					else 
// 						this.blockSetClass('ipdash');
// 				}
// 			},

// 			ipbulleted: {
// 				title: '&bull; ipbulleted',
// 				callback: function(buttonName, buttonDOM, buttonObj) {
// 					if (this.getParent().getAttribute('class') && this.getParent().getAttribute('class').search('ipbulleted')>=0)
// 						this.blockRemoveClass('ipbulleted');
// 					else 
// 						this.blockSetClass('ipbulleted');
// 				}
// 			}
// 		}
// 	}
// }
